// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-8f5e7402]::-webkit-outer-spin-button,\ninput[data-v-8f5e7402]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-8f5e7402] {\n  -moz-appearance: textfield;\n}\n.summary-bar[data-v-8f5e7402] {\n  padding: 16px 0;\n}", ""]);
// Exports
module.exports = exports;
